<template>
<div>
  <bordered-container title='Werkgerelateerde Gegevens'>
  <!-- <header-element class='mb-2'>Werkgerelateerde Gegevens</header-element> -->
  <employee-employment-relationship
    v-for="(relationship, i) in employmentRelationships"
    :key="'employment-relationship-' + i"
    :employmentRelationship="relationship"
    :employee="employee"
    :isOpen="openKey === 'employment-relationship-' + i"
    @click.native="() => handleToggleOpen(i)" />
  </bordered-container>
</div>
</template>

<script>
import EmployeeEmploymentRelationship from '@/views/components/employee-details/EmployeeEmploymentRelationship.vue';
import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';

export default {
  name: 'EmployeeEmploymentRelationships',
  props: {
    employmentRelationships: Array,
    employee: Object
  },
  data () {
    return {
      openKey: 'employment-relationship-0'
    };
  },
  components: {
    EmployeeEmploymentRelationship,
    BorderedContainer
  },
  methods: {
    handleToggleOpen (i) {
      this.openKey = 'employment-relationship-' + i;
    }
  }
};
</script>

<style>
</style>
